<template>
    <div class="android-search-box mdl-textfield mdl-js-textfield mdl-textfield--expandable mdl-textfield--floating-label mdl-textfield--align-right mdl-textfield--full-width mdc-menu-surface--anchor">
        <label class="mdl-button mdl-js-button mdl-button--icon mdc-ripple-surface" for="search-field">
            <i class="material-icons">search</i>
        </label>
        <div class="mdl-textfield__expandable-holder">
            <input class="mdl-textfield__input" type="text" id="search-field" name="term" v-on:keyup="autocomplete" v-model="term"/>
        </div>
        <div id="search-menu" class="mdc-menu mdc-menu-surface" data-mdc-auto-init="MDCMenu">
            <ul class="mdc-list">
                <li v-for="keyword in this.results" :data-term="keyword.name" v-on:click="showSearchView" class="mdc-list-item">
                    <span class="mdc-list-item__text">{{ keyword.name }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import {Corner} from '@material/menu'

    export default {
        props: {
            'route': {
                required: true,
                type: String | Location
            }
        },
        data: function() {
            return {
                'menu': null,
                'progressBar': null,
                'snackBar': $('.mdc-snackbar')[0].MDCSnackbar,
                'snackBarText': $('.mdc-snackbar__label'),
                'term': '',
                'results': [],
                'timer': null,
                'currentRequest': null,
            }
        },
        methods: {
            'autocomplete': function () {
                clearTimeout(this.timer);
                this.menu.open = false;

                this.timer = setTimeout(function() {
                    this.currentRequest = $.ajax({
                        url: this.route + '?term=' + this.term,
                        dataType: 'json',
                        beforeSend: function () {
                            this.progressBar.open();
                            if (this.currentRequest != null) {
                                this.currentRequest.abort();
                            }
                        }.bind(this),
                        success: function (response) {
                            this.results = response;
                            this.progressBar.close();
                            this.menu.open = true;
                        }.bind(this),
                        error: function (xhr, status, error) {
                            this.progressBar.close();

                            if (status === 'abort') {
                                return;
                            }

                            this.snackBarText.text('搜尋失敗');
                            this.snackBar.open();
                        }.bind(this),
                    })
                }.bind(this), 500);
            },
            showSearchView: function (event) {
                let data = $(event.currentTarget).data('term');
                console.log('Data:' + data);
                window.location = '/search?term=' + data;
            }
        },
        watch: {
            term: function (newVal) {
                if (!newVal || 0 === newVal.length) {
                    this.results = [];
                }
            }
        },
        mounted() {
            window.mdc.autoInit();
            this.menu = $('#search-menu')[0].MDCMenu;
            this.menu.setAnchorCorner(Corner.BOTTOM_START);

            this.progressBar = new $('.mdc-linear-progress')[0].MDCLinearProgress;

            let inputSelector = $('input.mdl-textfield__input');

            inputSelector.focus(function () {
                if (!this.menu.open && this.results.length > 0) {
                    this.menu.open = true
                }
            }.bind(this));
            
        }
    }
</script>